import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BootstrapModal from '../bootstrap-modal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'view-blob-dialog',
  props: {
    url: null,
    text: null
  },
  emits: ["update:url", "update:text", "dialog-closed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:url', value: string | undefined): void;
    (event: 'update:text', value: string | undefined): void;
    (event: 'dialog-closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    url?: string;
    text?: string;
}


//eslint-disable-next-line no-spaced-func

const showDialog = computed({
    get: () => !!(props.url || props.text),
    set: (val) => {
        if(!val) {
            emit('update:url', undefined);
            emit('update:text', undefined);
        }
    },
});

return { __sfc: true,props, emit, showDialog, BootstrapModal }
}

})